import * as types from './types';

export const setMetadata = (payload) => {
  return { type: types.METADATA, payload };
};


// WEBPACK FOOTER //
// ./src/actions/metadata/metadataActions.js